import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { OpenDialogGoToOfferSessionComponent } from 'app/components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { PricingOffer, Discount, Pricing } from 'app/shared/models/class/pricing-offer/pricingOffer';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-offer-edit-pricing',
  templateUrl: './admin-offer-edit-pricing.component.html',
  styleUrls: ['./admin-offer-edit-pricing.component.scss']
})
export class AdminOfferEditPricingComponent extends SubscriptionBaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() offer: FullOffer;
  @Input() file: any;
  @Input() tempoPricing: boolean;
  @Input() set hasSession(value: boolean) {
    this.hasSessionUpdate = value;
  }

  @Output() tab = new EventEmitter<string>();
  @Output() offerKeyOfNewOffer = new EventEmitter<string>();
  @Output() pricingOfferSaved = new EventEmitter<PricingOffer>();
  @Output() newTempoPricing = new EventEmitter<boolean>();
  @Output() exitEdition = new EventEmitter<boolean>();

  isPayableAtClub = true;
  isPayableOnline = false;

  color: ThemePalette = 'primary';
  cityRemVRES: string[] = [];
  userConnected: any;
  actionForm: string;
  baseFormPricing: PricingOffer;
  hasSessionUpdate: boolean;
  destroyComponent: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private uiService: UiService,
    private dataService: DataService,
    private offerService: OfferService,
    private authService: AuthService,
    private tooltip: TooltipService,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,

  ) {
    super();
  }

  ngOnInit() {
    this.initComponent();
    this.initSub();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.newOffer) {
      this.isPayableAtClub = changes.newOffer.currentValue?.isPayableAtClub ?? true;
      this.isPayableOnline = changes.newOffer.currentValue?.isPayableOnline ?? false;
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  formIsValid(): void {
    // if (this.f.offerName.value && this.f.clubCode.value && this.f.description.value && this.f.price.value) {
    //   this.loading = true;
    // }
  }

  changeToggle(toggle: string): void {

    switch (toggle) {
      case 'isPayableAtClub':
        this.isPayableAtClub = !this.isPayableAtClub;
        break;

      case 'isPayableOnline':
        this.isPayableOnline = !this.isPayableOnline;
        break;

      default:
        break;
    }

    if (this.isPayableAtClub && !this.isPayableOnline || !this.isPayableAtClub && this.isPayableOnline) {
      this.form.get('advancePayment').setValue(0);
      this.form.get('advancePayment').disable();
    } else {
      this.form.get('advancePayment').enable();
    }
  }

  addAgeGroup(): void {
    this.selectionAgeGroup.push(this.createAgeGroup());
    this.setValidatorsAgeGroup();
  }

  setValidatorsAgeGroup(): void {
    this.selectionAgeGroup.controls.forEach(async (el, i) => {
      const valuePrevious = this.selectionAgeGroup.controls[i - 1];
      const valueNext = this.selectionAgeGroup.controls[i + 1];
      const valueMin = el?.value.limits[0].min || 0;

      const min = valuePrevious ? +valuePrevious?.value.limits[0].max + 1 : 0;
      const max =
        valueNext ?
          +valueNext?.value.limits[0].min - 1 ?
            +valueNext?.value.limits[0].min - 1 :
            null :
          null;

      el['controls'].limits.controls[0].controls.min?.setValidators([Validators.min(min)]);
      el['controls'].limits.controls[0].controls.max?.setValidators([Validators.min(valueMin + 1), Validators.max(max)]);

    });
  }

  addCityInRemVRES(): void {
    if (this.f.remVRES.valid) {
      const index = this.f.cityRemVRES.value.findIndex(el => el === this.f.remVRES.value);
      index === -1 ?
        (this.f.cityRemVRES.value.push(this.f.remVRES.value), this.f.remVRES.reset()) :
        this.uiService.showSnackbar('Ce code postal existe déjà');
    } else {
      this.uiService.showSnackbar('Format du code postal est invalid - Uniquement 5 chiffres');
    }
  }

  deleteCityInRemVRES(index: number): void {
    this.f.cityRemVRES.value.splice(index, 1);
    this.setValidatorsAgeGroup();
  }

  checkValueMinAgeGroupValues(index: number): number {
    const value = this.selectionAgeGroup.value[index];
    return value ? value.limits : 0;
  }

  get selectionAgeGroup(): UntypedFormArray {
    return this.form.controls.remAge as UntypedFormArray;
  }

  get selectionRemQTE(): UntypedFormArray {
    return this.form.controls.remQTE as UntypedFormArray;
  }
  get selectionStagiaires(): UntypedFormArray {
    return this.form.controls.remStagiaires as UntypedFormArray;
  }

  getselectionAgeGroupValues(index: number): UntypedFormArray {
    return this.selectionAgeGroup['controls'][index]['controls'].limits as UntypedFormArray;
  }

  private createQuantityPercentage(pricing?: Discount): UntypedFormGroup {
    return this.formBuilder.group({
      quantity: [pricing ? pricing.criteria : ''],
      reduction: [pricing ? pricing.discount : '']
    });
  }

  private createAgeGroup(pricing?: Pricing): UntypedFormGroup {
    return this.formBuilder.group({
      limits: this.formBuilder.array([this.createAgeGroupMinMax(pricing?.limits as string)]),
      price: [pricing ? pricing.price : '']
    });
  }

  private createAgeGroupMinMax(limits: string): UntypedFormGroup {
    const limitsSplit = limits?.split('#');
    return this.formBuilder.group({
      min: [limits ? limitsSplit[0] : ''],
      max: [limits ? limitsSplit[1] : '']
    });
  }

  deletedSelectionAgeGroup(index: number): void {
    this.selectionAgeGroup.removeAt(index);
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private saveImgOffer(offerKey: number, file: any): void {
    this.offerService.uploadImg(offerKey, [file], true).subscribe({
      next: () => { }
    });
  }

  private formatPricing(): PricingOffer {
    const pricing: Pricing[] = [new Pricing(null, this.f.fixedPrice.value)];
    this.f.remAge.value.forEach(el => {
      const limit = `${el.limits[0].min}#${el.limits[0].max}`;
      const rem = new Pricing(limit, el.price);
      pricing.push(rem);
    });

    const discount: Discount[] = [];
    discount.push(new Discount('RemQTE', this.f.remQTE?.value[0]?.quantity || 0, this.f.remQTE?.value[0]?.reduction));
    discount.push(new Discount('RemTFED', null, this.f.remTFED?.value));
    discount.push(new Discount('RemRES', this.f.cityRemVRES.value.join('#'), this.f.remVRESPercentage?.value));
    discount.push(new Discount('RemStagiaires', this.f.remStagiaires?.value[0]?.quantity || 0, this.f.remStagiaires?.value[0]?.reduction));

    const pricingOffer: PricingOffer = {
      advancePayment: this.f.advancePayment.value,
      fixedPrice: this.f.fixedPrice.value,
      isPayableAtClub: this.f.isPayableAtClub.value,
      isPayableOnline: this.f.isPayableOnline.value,
      pricing,
      discount,
    };
    return pricingOffer;
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
  }

  get f() {
    return this.form.controls;
  }

  private initForm(): void {
    if (this.offer) {
      this.isPayableAtClub = this.offer.isPayableAtClub;
      this.isPayableOnline = this.offer.isPayableOnline;
    }


    if (this.isPayableAtClub && !this.isPayableOnline || !this.isPayableAtClub && this.isPayableOnline) {
      this.form.get('advancePayment').disable();
    } else {
      this.form.get('advancePayment').enable();
    }

    this.baseFormPricing = { ...this.formatPricing() };
    this.setValuesForm();
  }

  private setValuesForm(): void {
    const { discount } = this.offer ?? this.baseFormPricing;

    discount?.forEach((d: Discount, i: number) => {

      switch (d.discountName) {
        case 'RemQTE':
          this.selectionRemQTE.push(this.createQuantityPercentage(d));
          break;

        case 'RemTFED':
          this.f.remTFED.setValue(d.discount);
          break;

        case 'RemRES':
          this.f.remVRESPercentage.setValue(d.discount);
          this.f.cityRemVRES.setValue(d.criteria?.length ? d.criteria.split('#') : []);
          break;

        case 'RemStagiaires':
          this.selectionStagiaires.push(this.createQuantityPercentage(d));
          break;

        default:
          break;
      }
    });


    this.offer?.pricing?.forEach(((p: Pricing, i: number) => {
      if (i > 0) { this.selectionAgeGroup.push(this.createAgeGroup(p)); }
    }));
  }

  private initSub(): void {
    this.initForm();

    this.subscription
      .add(
        this.dataService.actionFormOfferAdmin.subscribe({
          next: actionForm => {
            this.actionForm = actionForm;
          }
        })
      )
      .add(
        this.dataService.offerPreview.subscribe({
          next: oP => {
            if (this.actionForm === 'edit' && !this.tempoPricing) {
              this.tempoPricing = true;
              this.offer = new PricingOffer(oP);
              this.initForm();
            }
          }
        })
      )
      .add(
        this.dataService.destroyComponent$.subscribe({
          next: destroy => {
            this.destroyComponent = destroy;
            this.cdr.detectChanges();
          }
        })
      );
  }

  ngOnDestroy() {
    if (this.destroyComponent) {
      const pricing: PricingOffer = this.formatPricing();
      const base = JSON.stringify(this.baseFormPricing);
      const newPricing = JSON.stringify(pricing);
      const isTheSame = base === newPricing ? true : false;
      if (!isTheSame) {
        this.pricingOfferSaved.emit(this.formatPricing());
        this.newTempoPricing.emit(true);
      }
    }
    // TODO tester le unsub
    this.subscription.unsubscribe();
  }

}
